const imports = [

    { selector: "#instructions", module: () => require('../instructions/instructions.js') },
    { selector: "#inbox_items", module: () => require('../memorandum/inbox/index.js') },
    { selector: "#conference", module: () => require('../conference/conference.js') },
    { selector: "#calendar_vacation", module: () => require('../calendar/calendar.js') },
    { selector: "#calendar_trip", module: () => require('../calendar/calendar.js') },
    { selector: "#counterparty_items", module: () => require('../counterparty/counterparty_items.js') },
    { selector: "#memorandum_create", module: () => require('../memorandum/create/memorandum_create.js') },
    { selector: "#memorandum_inside", module: () => require('../memorandum/inside/mem_inside.js') },
    { selector: "#radu_editor", module: () => require('../radu/radu.js') },
    { selector: "#email_forward_editor", module: () => require('../email/forwards/forwards.js') },
    { selector: "#email_editor", module: () => require('../email/list/email_list.js') },
    { selector: "#equipment_editor", module: () => require('../equipments/equipments.js') },
    { selector: "#internal_inside", module: () => require('../internal_docs/inside/inside.js') },
    { selector: "#edit_internal", module: () => require('../internal_docs/edit/edit_internal.js') },
    { selector: "#hr", module: () => require('../hr/hr.js') },
    { selector: "#ttn_remove", module: () => require('../ttn/ttn_remove.js') },
    { selector: "#ttn_save", module: () => require('../ttn/ttn_save.js') },
    { selector: "#declaration", module: () => require('../declaration/declaration.js') },
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});


